import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../icon/Icon'

export default function Button({
  className,
  text,
  href,
  icon,
  iconClassName,
  primary,
  secondary,
  textlink,
  block,
  small,
  onClick,
  ...props
}) {
  const Tag = href ? 'a' : 'button'
  return (
    <Tag
      className={clsx(
        'btn',
        block && 'btn-block',
        primary && 'btn-primary',
        secondary && 'btn-secondary',
        textlink && 'btn-text-link',
        small && 'btn--small',
        className
      )}
      href={href}
      onClick={onClick}
      role="button"
      {...props}
    >
      {text && <span>{text}</span>}
      {icon && <Icon className={iconClassName} name={icon} />}
    </Tag>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  textlink: PropTypes.bool,
  block: PropTypes.bool,
  small: PropTypes.bool,
  onClick: PropTypes.func
}

Button.defaultProps = {
  iconClassName: ''
}
